import { View } from "react-native";
import { Image } from "expo-image";
import { useThemeColors, useTheme } from "@/providers/ThemeProvider";
import { useAuth } from "@/providers/AuthProvider";
import LottieView from "lottie-react-native";

/**
 * No Weekend Banner Component
 * Displays when there's no active family weekend
 * Layered design: Semi-circle backgrounds, Opa & Oma, Staatsen App text on top
 */
export function NoWeekendBanner() {
  const colors = useThemeColors();
  const { isDark } = useTheme();
  const { activeWeekend } = useAuth();

  // Only show when there's no active weekend
  if (activeWeekend) return null;

  return (
    <View
      className="mx-4 mt-4 rounded-2xl overflow-hidden"
      style={{
        backgroundColor: colors.surface,
        borderWidth: 2,
        borderColor: colors.border,
        height: 200,
      }}
    >
      {/* Semi-circle backgrounds (pure white) */}
      <View className="absolute inset-0 flex-row justify-between items-end">
        {/* Left semi-circle for Opa */}
        <View
          style={{
            width: 180,
            height: 180,
            borderRadius: 90,
            backgroundColor: "#FFFFFF",
            marginLeft: -50,
            marginBottom: -40,
          }}
        />
        {/* Right semi-circle for Oma */}
        <View
          style={{
            width: 200,
            height: 200,
            borderRadius: 100,
            backgroundColor: "#FFFFFF",
            marginRight: -60,
            marginBottom: -50,
          }}
        />
      </View>

      {/* Background Layer: Opa (left) & Oma (right) - aligned to bottom */}
      <View className="absolute inset-0 flex-row justify-between items-end">
        {/* Opa - aligned to bottom */}
        <Image
          source={require("@/assets/splashscreen_images/opa_schets_zonder_achtergrond.svg")}
          style={{
            width: 130,
            height: 150,
            marginLeft: -20,
            marginBottom: -10,
          }}
          contentFit="contain"
          cachePolicy="memory-disk"
        />

        {/* Oma - aligned to bottom */}
        <Image
          source={require("@/assets/splashscreen_images/oma_zonder_achtergrond.svg")}
          style={{
            width: 160,
            height: 180,
            marginRight: -10,
            marginBottom: -35,
          }}
          contentFit="contain"
          cachePolicy="memory-disk"
        />
      </View>

      {/* Foreground Layer: Lottie + Text centered */}
      <View className="absolute inset-0 items-center justify-center">
        {/* Group Lottie Animation */}
        <LottieView
          source={require("@/assets/lottie/Group.json")}
          autoPlay
          loop
          style={{ width: 100, height: 100 }}
        />

        {/* Staatsen App Text - larger and prominent */}
        <Image
          source={require("@/assets/splashscreen_images/text_splashscreen.svg")}
          style={{
            width: 200,
            height: 120,
            marginTop: -30,
          }}
          contentFit="contain"
          cachePolicy="memory-disk"
        />
      </View>
    </View>
  );
}
